module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-bldg-apart-small-ff8dca55789cea78ed3c48091b1d54c0.png";